import React from "react";
import { Navigate, Route, RouteProps } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import HeadLink from "../pages/other/HeadLink";
import LocationPage from "../pages/Location/LocationPage";
const Login = React.lazy(() => import("../pages/auth/Login"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));
const Confirm = React.lazy(() => import("../pages/auth/Confirm"));
const ForgetPassword = React.lazy(() => import("../pages/auth/ForgetPassword"));
const Register = React.lazy(() => import("../pages/auth/Register"));
const LockScreen = React.lazy(() => import("../pages/auth/LockScreen"));
const ForgotPasswordLink = React.lazy(
  () => import("../pages/auth/ForgotPasswordLink")
);
const StudentLogin = React.lazy(() => import("../pages/auth/StudentLogin"));
const Landing = React.lazy(() => import("../pages/landing"));
const AboutLanding = React.lazy(() => import("../pages/landing/About"));
const HelpDesk = React.lazy(() => import("../pages/landing/Helpdesk"));
const Mbbsdesc = React.lazy(() => import("../pages/landing/mbbs"));
const DummyStudentProfile = React.lazy(
  () => import("../pages/other/Profile/index")
);
const ViewAttendance = React.lazy(() => import("../pages/tables/Advanced"));
const AttendaceSheet = React.lazy( () => import("../pages/other/Profile/OtherDetails/attendance"));
const AthleteExplorer   = React.lazy(() => import("../pages/apps/AthleteExplorer"));
const EmployeePage   = React.lazy(() => import("../pages/apps/EmployeePage"));
const WeededOutEmployeesPage = React.lazy(() => import("../pages/apps/EmployeePage/WeededOutEmployeesPage"));
const ManagerPortal   = React.lazy(() => import("../pages/manager-portal"));
const OnboardingPage = React.lazy(() => import("../pages/onboarding/Onboarding"));
const OnboardingChecklistPage = React.lazy(() => import("../pages/onboarding-checklist/OnboardingChecklistPage"));
const OnboardingReviewPage = React.lazy(() => import("../pages/onboarding-review/OnboardingReviewPage"));
const TrackAttendance    = React.lazy(() => import("../pages/track-attendance"));
const UserTrackAttendance = React.lazy(() => import("../pages/track-attendance/UserTrackAttendance"));
const CorrectAttendance = React.lazy(() => import("../pages/correct-attendance"));

// ── Talent Identification Admin Panel ─────────────────────────────────────────
const AdminLayout            = React.lazy(() => import("../pages/admin/AdminLayout"));
const ParametersPage         = React.lazy(() => import("../pages/admin/parameters/ParametersPage"));
const NormalizationPage      = React.lazy(() => import("../pages/admin/normalization/NormalizationPage"));
const CompositePage          = React.lazy(() => import("../pages/admin/composite/CompositePage"));
const AthletePerformancePage = React.lazy(() => import("../pages/admin/athletePerformance/AthletePerformancePage"));
const LeaderboardPage        = React.lazy(() => import("../pages/admin/athletePerformance/LeaderboardPage"));
const AttendanceNotifications        = React.lazy(() => import("../pages/finance/notifications"));
const PayrollPage                    = React.lazy(() => import("../pages/finance/payroll/PayrollPage"));
const IncentivesPage                 = React.lazy(() => import("../pages/finance/payroll/incentives/IncentivesPage"));
const SalaryStructuresPage           = React.lazy(() => import("../pages/finance/payroll/salary/SalaryStructuresPage"));
const PayrollSettingsPage            = React.lazy(() => import("../pages/finance/payroll/settings/PayrollSettingsPage"));
const MyPayslipsPage                 = React.lazy(() => import("../pages/finance/payslips/MyPayslipsPage"));
const LetterPage                     = React.lazy(() => import("../pages/hr/letters/LetterPage"));
const LeaveJoiningLetterPage         = React.lazy(() => import("../pages/finance/letters/LeaveJoiningLetterPage"));
const MyLettersPage                  = React.lazy(() => import("../pages/my-letters/MyLettersPage"));

const AttendanceManagementPage = React.lazy(
  () => import('../pages/attendance/AttendanceManagementPage')
);

const LeaveWfhPage = React.lazy(
  () => import('../pages/leave-wfh/LeaveWfhPage')
);

const SettingsPage = React.lazy(
  () => import('../pages/settings/SettingsPage')
);

const EcommerceDashboard = React.lazy(
  () => import("../pages/dashboard/Ecommerce/attandance")
);

const EcommerceDashboard1 = React.lazy(
  () => import("../pages/dashboard/Ecommerce/attandance")
);
const EcommerceDashboard2 = React.lazy(
  () => import("../pages/dashboard/Ecommerce/attandance2")
);

const RoleDashboard = React.lazy(
  () => import("../pages/dashboard/RoleDashboard")
);

const AnalyticsDashboardPG = React.lazy(
  () => import("../pages/dashboard/AnalyticsPG")
);

const HomeDashboard = React.lazy(
  () => import("../pages/dashboard/Home/HeaderTwo")
);

//------------------------------------- apps  -----------------------------------
const CalendarApp = React.lazy(() => import("../pages/apps/Calendar"));
const Projects = React.lazy(() => import("../pages/apps/Projects"));
const ProjectDetail = React.lazy(() => import("../pages/apps/Projects/Detail"));
// ----------------------------------------- chat  ---------------------------------
const ChatApp = React.lazy(() => import("../pages/apps/Chat"));
// - email
const Inbox = React.lazy(() => import("../pages/apps/Email/Inbox"));
const EmailDetail = React.lazy(() => import("../pages/apps/Email/Detail"));
const EmailCompose = React.lazy(() => import("../pages/apps/Email/Compose"));
// - tasks
const TaskList = React.lazy(() => import("../pages/apps/Tasks/List"));
const Kanban = React.lazy(() => import("../pages/apps/Tasks/Board"));
// - file
const FileManager = React.lazy(() => import("../pages/apps/FileManager"));

// extra pages
const Error404 = React.lazy(() => import("../pages/error/Error404"));
const Error500 = React.lazy(() => import("../pages/error/Error500"));
// -other
const Starter = React.lazy(() => import("../pages/other/Starter"));
const Profile = React.lazy(() => import("../pages/other/Profile"));
const Activity = React.lazy(() => import("../pages/other/Activity"));
const Invoice = React.lazy(() => import("../pages/other/Invoice"));
const Maintenance = React.lazy(() => import("../pages/other/Maintenance"));
const Pricing = React.lazy(() => import("../pages/other/Pricing"));
const About = React.lazy(() => import("../pages/other/About"));

// ---------------------------------------- Pages ------------------------

// uikit
const UIElements = React.lazy(() => import("../pages/uikit"));

// widgets
const Widgets = React.lazy(() => import("../pages/widgets"));

// icons
const Unicons = React.lazy(() => import("../pages/icons/Unicons"));
const FeatherIcons = React.lazy(() => import("../pages/icons/Feather"));
const BootstrapIcon = React.lazy(() => import("../pages/icons/Bootstrap"));

// forms
const BasicForms = React.lazy(() => import("../pages/forms/Basic"));
const FormAdvanced = React.lazy(() => import("../pages/forms/Advanced"));
const FormValidation = React.lazy(() => import("../pages/forms/Validation"));
const FormWizard = React.lazy(() => import("../pages/forms/Wizard"));
const FileUpload = React.lazy(() => import("../pages/forms/FileUpload"));
const Editors = React.lazy(() => import("../pages/forms/Editors"));
// charts
const Charts = React.lazy(() => import("../pages/charts"));
// tables
const BasicTables = React.lazy(() => import("../pages/tables/Basic"));
const AdvancedTables = React.lazy(() => import("../pages/tables/Advanced"));
// maps
const GoogleMaps = React.lazy(() => import("../pages/maps/GoogleMaps"));

export interface RoutesProps {
  path: RouteProps["path"];
  name?: string;
  element?: RouteProps["element"];
  route?: any;
  exact?: boolean;
  icon?: string;
  header?: string;
  roles?: string[];
  children?: RoutesProps[];
}

// ------------------------------------dashboards --------------------------------
const dashboardRoutes: RoutesProps = {
  path: "/dashboard",
  name: "Dashboards",
  icon: "airplay",
  header: "Navigation",
  children: [
    {
      path: "/dashboard",
      name: "Root",
      element: <RoleDashboard />,
      route: PrivateRoute,
    },

    // // NewDashboard
    {
      path: "/dashboard/ecommerce",
      name: "Ecommerce",
      element: <EcommerceDashboard />,
      route: PrivateRoute,
    },

    // {
    //   path: "/dashboard/attandance",
    //   name: "Ecommerce",
    //   element: <EcommerceDashboard1 />,
    //   route: PrivateRoute,
    // },
    // {
    //   path: "/dashboard/analytics",
    //   name: "Analytics",
    //   element: <AnalyticsPage />,
    //   route: PrivateRoute,
    // },
    {
      path: "/dashboard/analyticspg",
      name: "Analytics PG",
      element: <AnalyticsDashboardPG />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard/attendance",
      name: "Attendance Management",
      element: <AttendanceManagementPage />,
      route: PrivateRoute,
    },
    
  ],
};

const calendarAppRoutes: RoutesProps = {
  path: "/apps/calendar",
  name: "Calendar",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "calendar",
  element: <CalendarApp />,
  header: "Apps",
};

const chatAppRoutes: RoutesProps = {
  path: "/apps/chat",
  name: "Chat",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ChatApp />,
};

const emailAppRoutes: RoutesProps = {
  path: "/apps/email",
  name: "Email",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "mail",
  children: [
    {
      path: "/apps/email/inbox",
      name: "Inbox",
      element: <Inbox />,
      route: PrivateRoute,
    },
    {
      path: "/apps/email/details",
      name: "Email Details",
      element: <EmailDetail />,
      route: PrivateRoute,
    },
    {
      path: "/apps/email/compose",
      name: "Compose Email",
      element: <EmailCompose />,
      route: PrivateRoute,
    },
  ],
};

const projectAppRoutes: RoutesProps = {
  path: "/apps/projects",
  name: "Projects",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "uil-briefcase",

  children: [
    {
      path: "/apps/projects/list",
      name: "List",
      element: <Projects />,
      route: PrivateRoute,
    },
    {
      path: "/apps/projects/details",
      name: "Detail",
      element: <ProjectDetail />,
      route: PrivateRoute,
    },
  ],
};

const taskAppRoutes: RoutesProps = {
  path: "/apps/tasks",
  name: "Tasks",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "clipboard",
  children: [
    {
      path: "/apps/tasks/list",
      name: "Task List",
      element: <TaskList />,
      route: PrivateRoute,
    },

    {
      path: "/apps/tasks/kanban",
      name: "Kanban",
      element: <Kanban />,
      route: PrivateRoute,
    },
  ],
};

const fileAppRoutes: RoutesProps = {
  path: "/apps/file-manager",
  name: "File Manager",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "folder-plus",
  element: <FileManager />,
};

const appRoutes = [
  calendarAppRoutes,
  chatAppRoutes,
  emailAppRoutes,
  projectAppRoutes,
  taskAppRoutes,
  fileAppRoutes,
];

// ── Talent Identification Admin routes ────────────────────────────────────────

const talentAdminRoutes: RoutesProps = {
  path: "/admin",
  name: "Talent Admin",
  icon: "trophy",
  children: [
    {
      path: "/admin/parameters",
      name: "Performance Parameters",
      element: (
        <AdminLayout>
          <ParametersPage />
        </AdminLayout>
      ),
      route: PrivateRoute,
    },
    {
      path: "/admin/normalization",
      name: "Normalization Rules",
      element: (
        <AdminLayout>
          <NormalizationPage />
        </AdminLayout>
      ),
      route: PrivateRoute,
    },
    {
      path: "/admin/composite",
      name: "Composite Score Rules",
      element: (
        <AdminLayout>
          <CompositePage />
        </AdminLayout>
      ),
      route: PrivateRoute,
    },
    {
      path: "/finance/notifications",
      name: "Notifications",
      element: <AttendanceNotifications />,
      route: PrivateRoute,
    },
    {
      path: "/finance/payroll",
      name: "Payroll & Reports",
      element: <PayrollPage />,
      route: PrivateRoute,
    },
    {
      path: "/finance/payroll/incentives",
      name: "Performance Incentives",
      element: <IncentivesPage />,
      route: PrivateRoute,
    },
    {
      path: "/finance/payroll/settings",
      name: "Payroll Settings",
      element: <PayrollSettingsPage />,
      route: PrivateRoute,
    },
    {
      path: "/finance/payroll/salary-structures",
      name: "Salary Structures",
      element: <SalaryStructuresPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/my-payslips",
      name: "My Payslips",
      element: <MyPayslipsPage />,
      route: PrivateRoute,
    },
    {
      path: "/hr/letters",
      name: "Employee Letters",
      element: <LetterPage />,
      route: PrivateRoute,
    },
    {
      path: "/finance/letters/leave-joining",
      name: "Leave/Joining Letter",
      element: <LeaveJoiningLetterPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/my-letters",
      name: "My Letters",
      element: <MyLettersPage />,
      route: PrivateRoute,
    },
    {
      path: "/admin/leaderboard",
      name: "Leaderboard",
      element: (
        <AdminLayout>
          <LeaderboardPage />
        </AdminLayout>
      ),
      route: PrivateRoute,
    },
  ],
};

// pages
const extrapagesRoutes: RoutesProps = {
  // ------------------------------- Pages section --------------------

  path: "/pages",
  name: "Pages",
  icon: "package",
  header: "Custom",
  children: [
    // Start Student management system routes

    // Start Student dashboard routes

    // {
    //   path: "/pages/athletes",
    //   name: "Athlete Explorer",
    //   element: <AthleteExplorer />,
    //   route: PrivateRoute,
    // },
    {
      path: "/pages/employee",
      name: "Employee",
      element: <EmployeePage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/employee/weeded-out",
      name: "Weeded Out Employees",
      element: <WeededOutEmployeesPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/manager-portal",
      name: "Manager Portal",
      element: <ManagerPortal />,
      route: PrivateRoute,
    },

      {
      path: "/pages/locations",
      name: "Location Management",
      element: <LocationPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/onboarding",
      name: "Onboarding",
      element: <OnboardingPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/onboarding-checklist",
      name: "Onboarding Checklist",
      element: <OnboardingChecklistPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/onboarding-review",
      name: "Onboarding Review",
      element: <OnboardingReviewPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/track-attendance",
      name: "Track Attendance",
      element: <TrackAttendance />,
      route: PrivateRoute,
    },
    {
      path: "/pages/my-attendance",
      name: "My Attendance",
      element: <UserTrackAttendance />,
      route: PrivateRoute,
    },
    {
      path: "/pages/correct-attendance",
      name: "Correct Attendance",
      element: <CorrectAttendance />,
      route: PrivateRoute,
    },
    {
      path: "/pages/leave-wfh",
      name: "Leave & WFH",
      element: <LeaveWfhPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/settings",
      name: "Settings",
      element: <SettingsPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/about",
      name: "About",
      element: <About />,
      route: PrivateRoute,
    },
  ],
};

// ui
const uiRoutes: RoutesProps = {
  path: "/components",
  name: "Components",
  icon: "package",
  header: "UI Elements",
  children: [
    {
      path: "/components/ui-elements",
      name: "UIElements",
      element: <UIElements />,
      route: PrivateRoute,
    },
    {
      path: "/components/widgets",
      name: "Widgets",
      element: <Widgets />,
      route: PrivateRoute,
    },
    {
      path: "/icons",
      name: "Icons",
      children: [
        {
          path: "/icons/unicons",
          name: "Unicons",
          element: <Unicons />,
          route: PrivateRoute,
        },
        {
          path: "/icons/feather",
          name: "Feather",
          element: <FeatherIcons />,
          route: PrivateRoute,
        },
        {
          path: "/icons/bootstrap",
          name: "Bootstrap Icon",
          element: <BootstrapIcon />,
          route: PrivateRoute,
        },
      ],
    },

    // ---------------------------------insert data inside home section -------------------

    {
      path: "/forms",
      name: "Forms",
      children: [

        {
          path: "/forms/basic",
          name: "Basic Elements",
          element: <BasicForms />,
          route: PrivateRoute,
        },
        {
          path: "/forms/advanced",
          name: "Form Advanced",
          element: <FormAdvanced />,
          route: PrivateRoute,
        },
        {
          path: "/forms/validation",
          name: "Form Validation",
          element: <FormValidation />,
          route: PrivateRoute,
        },

        {
          path: "/pages/headlink",
          name: "Form Head Link",
          element: <HeadLink />,
          route: PrivateRoute,
        },

        {
          path: "/forms/wizard",
          name: "Form Wizard",
          element: <FormWizard />,
          route: PrivateRoute,
        },
        {
          path: "/forms/upload",
          name: "File Upload",
          element: <FileUpload />,
          route: PrivateRoute,
        },
        {
          path: "/forms/editors",
          name: "Editors",
          element: <Editors />,
          route: PrivateRoute,
        },
      ],
    },

    {
      path: "/components/charts",
      name: "Charts",
      element: <Charts />,
      route: PrivateRoute,
    },
    {
      path: "/tables",
      name: "Tables",
      children: [
        {
          path: "/tables/basic",
          name: "Basic",
          element: <BasicTables />,
          route: PrivateRoute,
        },
        {
          path: "/tables/advanced",
          name: "Advanced",
          element: <AdvancedTables />,
          route: PrivateRoute,
        },
      ],
    },
    {
      path: "/maps",
      name: "Maps",
      children: [
        {
          path: "/maps/googlemaps",
          name: "Google Maps",
          element: <GoogleMaps />,
          route: PrivateRoute,
        },
      ],
    },
  ],
};

// auth
const authRoutes: RoutesProps[] = [
  {
    path: "/auth/login",
    name: "Login",
    element: <Login />,
    route: Route,
  },
  {
    path: "/school/login",
    name: "Student Login",
    element: <StudentLogin />,
    route: Route,
  },
  {
    path: "/auth/register",
    name: "Register",
    element: <Register />,
    route: Route,
  },
  {
    path: "/auth/confirm",
    name: "Confirm",
    element: <Confirm />,
    route: Route,
  },
  {
    path: "/auth/forget-password",
    name: "Forget Password",
    element: <ForgetPassword />,
    route: Route,
  },
  {
    path: "/auth/lock-screen",
    name: "Lock Screen",
    element: <LockScreen />,
    route: Route,
  },
  {
    path: "/auth/logout",
    name: "Logout",
    element: <Logout />,
    route: Route,
  },
  {
    path: "/auth/reset-password/:token",
    name: "Forgot Password Via Mail",
    element: <ForgotPasswordLink />,
    route: Route,
  },
];

// public routes
const otherPublicRoutes: RoutesProps[] = [
  {
    path: "/home",
    name: "home",
    element: <Landing />,
    route: Route,
  },
  {
    path: "/about",
    name: "about",
    element: <AboutLanding />,
    route: Route,
  },
  {
    path: "/helpdesk",
    name: "helpdesk",
    element: <HelpDesk />,
    route: Route,
  },
  {
    path: "/mbbs",
    name: "helpdesk",
    element: <Mbbsdesc />,
    route: Route,
  },
  {
    path: "/dummy-studentProfile",
    name: "Student Profile",
    element: <DummyStudentProfile />,
    route: Route,
  },
  {
    path: "/viewAttendance",
    name: "View Attendance",
    element: <EcommerceDashboard1 />,
    route: Route,
  },
  {
    path: "/viewAttendance1",
    name: "View Attendance",
    element: <EcommerceDashboard2 />,
    route: Route,
  },

  {
    path: "/attendaceSheet",
    name: "View Attendance",
    element: <AttendaceSheet />,
    route: Route,
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    element: <Maintenance />,
    route: Route,
  },
  {
    path: "/error-404",
    name: "Error - 404",
    element: <Error404 />,
    route: Route,
  },

  {
    path: "/error-500",
    name: "Error - 500",
    element: <Error500 />,
    route: Route,
  },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
  let flatRoutes: RoutesProps[] = [];

  routes = routes || [];
  // console.log('routes', routes)
  routes.forEach((item: RoutesProps) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const authProtectedRoutes = [
  dashboardRoutes,
  ...appRoutes,
  talentAdminRoutes,
  extrapagesRoutes,
  uiRoutes,
];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);

export {
  publicRoutes,
  authProtectedRoutes,
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
};
